import { render, staticRenderFns } from "./SimpleFooter.vue?vue&type=template&id=1a854eac&scoped=true&"
import script from "./SimpleFooter.vue?vue&type=script&lang=js&"
export * from "./SimpleFooter.vue?vue&type=script&lang=js&"
import style0 from "./SimpleFooter.vue?vue&type=style&index=0&id=1a854eac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a854eac",
  null
  
)

export default component.exports